import * as consts from '../constants';
import initialState from './initialState';

export default function userReducer(state = initialState.agentState, action) {
    switch (action.type) {
        case consts.ACTONS.LOAD_USERS_SUCCESS:
            return action.pagingModel;
        case consts.ACTONS.LOAD_USERS_FAILED:
            return initialState.userState;
        default:
            return state;
    }
}
